module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b1042e3dc7977193ae4dffa54728a84b.png";